import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventsActions, MessagesActions } from '../../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faImages, faClock, faHeart} from '@fortawesome/fontawesome-free-solid';
import { Input, Submit, Checkbox } from '../../Form';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'moment/locale/he';
import { BoxTitle } from '../../PageTemplate';
import { Validation, ValidateDate } from '../../../helper';
import 'react-datepicker/dist/react-datepicker.css';
import './eventSettingsForm.scss';

const {REACT_APP_MAX_IMAGES_EVENT, REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS} = process.env;

moment.locale('he');

class EventSettingsForm extends Component {
    constructor(props) {
        super(props);

        const now = moment();
        this.state = {
            data: {
                name: "",
                date: {
                    start: "",
                    end: ""
                },
                closed: false,
                maxImages: {
                    event: REACT_APP_MAX_IMAGES_EVENT,
                    user: "",
                    copy: ""
                },
                website: {
                    title: ""
                },
            },
            error: {
                name: false,
                date: {
                    start: false,
                    end: false
                },
                maxImages: {
                    event: false,
                    user: false,
                    copy: false
                },
                website: {
                    title: false
                }
            },
            eventStarted: false,
            eventFinised: false,
            dateRange: {
                start: {
                    minDate: now,
                    maxDate: moment().add(1, 'year'),
                    minTime: moment().hours(now.hours()).minutes(now.minutes()),
                    maxTime: moment().hours(23).minutes(59)
                },
                end: {
                    minDate: null,
                    maxDate: null,
                    minTime: null,
                    maxTime: null
                }
            }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleClosedChange = this.handleClosedChange.bind(this);
        this.updateStartDateRange = this.updateStartDateRange.bind(this);
        this.updateEndDateRange = this.updateEndDateRange.bind(this);        
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const events = props.events.list;
        if(!events || !events[props.events.currentEventID]) return null;

        const currentEvent = events[props.events.currentEventID];
        if(Object.is(currentEvent, state.data)) return null;

        function replaceNullWithEmptyString(obj) {
            for(let p in obj) {
                if(typeof obj[p] === 'object') obj[p] = replaceNullWithEmptyString(obj[p]);
                if(obj[p] === null) obj[p] = '';
            }

            return obj;
        }

        // replace null with empty string (prevent uncontrolled input)
        replaceNullWithEmptyString(currentEvent);

        // add website.title if not exists (prevent uncontrolled input)
        if(!currentEvent.website.hasOwnProperty('title')) currentEvent.website.title = "";

        const {date} = currentEvent;

        return {
            data: currentEvent,
            eventStarted: ValidateDate.isSameOrBeforeNow(date.start, date.timeZone),
            eventFinised: ValidateDate.itsPast(date.end, date.timeZone)
        }
    }

    validation() {
        const {dispatch} = this.props;
        const {data} = this.state;
        const maxHours = REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS;
        const tz = data.date.timeZone;
        const start = data.date.start;
        const end = data.date.end;

        const invalidStartDate = moment(start) != null && ValidateDate.earlierFromNow(start, tz) && !this.state.eventStarted;
        const invalidEndDate = moment(start) != null && moment(end) != null && ValidateDate.houresRangeLimitExceeded(start, end, maxHours, 0, tz);

        if(invalidStartDate) {
            dispatch(MessagesActions.pushError('לא ניתן לבחוז זמן התחלה הקודם לעכשיו'));
        }

        if(invalidEndDate) {
            dispatch(MessagesActions.pushError(`זמו סיום האירוע לא תקין: הזמן המקסימלי לאירוע הוא ${maxHours} שעות`));
        }

        const invalidRange = (num) =>  !!!num || num < 0 || num > REACT_APP_MAX_IMAGES_EVENT;

        var err = {
            name: (data.name.trim().length < 5),
            website: {
                title: (data.website.title.length > 200)
            },
            maxImages: {
                event: !Validation.onlyNumbers(data.maxImages.event) || invalidRange(data.maxImages.event),
                user: !Validation.onlyNumbers(data.maxImages.user) || invalidRange(data.maxImages.user),
                copy: !Validation.onlyNumbers(data.maxImages.copy) || invalidRange(data.maxImages.copy)
            },
            date: {
                start: invalidStartDate,
                end: invalidEndDate
            }
        }

        this.setState({error: {...this.state.error, ...err}});

        const hasError = JSON.stringify(err);
        return hasError.indexOf(true) === -1;
    }

    updateStartDateRange(date) {
        const now = moment();
        const range = {...this.state.dateRange};

        range.start.minTime = moment().hours(now.hours()).minutes(now.minutes());

        // if date day is not currnet day -> start time from 0:00 (and not from current time)
        if(date && moment(date) !== null) {
            if(moment(date).date() !== moment().date()) {
                range.start.minTime = moment().hours(0).minute(0);
            }
        }

        this.setState({dateRange: range});
        this.updateEndDateRange();
    }

    updateEndDateRange(date) {
        const { start, timeZone } = this.state.data.date;

        if(moment(start) === null) return;

        const range = {...this.state.dateRange};

        // min date - now if event started or event start time if not
        range.end.minDate = this.state.eventStarted ? moment() : moment(start);
        // max date - start time + max hours of event
        range.end.maxDate = moment(start).tz(timeZone).add(REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS, 'hours');
        // min time - this.minDate time (now or event start time)
        range.end.minTime = moment().tz(timeZone).hours(range.end.minDate.hours()).minutes(range.end.minDate.minutes());
        // max time - this.maxDate time (start time + limit hours)
        range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());

        // if (min day) != (max day) && (max date <= end date) show range untile end of the day
        if(range.end.maxTime <= range.end.minTime && range.end.minDate.date() !== range.end.maxDate.date()) {
            range.end.maxTime = moment().tz(timeZone).hours(23).minutes(59);
        }

        if(date && moment(date) !== null) {
            // if date day is not currnet day -> start time from 0:00 (and not from current time)
            if(moment(date).date() !== range.end.minDate.date()) {
                range.end.minTime = moment().tz(timeZone).hours(0).minute(0);
                range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());
            } 
        }

        this.setState({dateRange: range});
    }

    updateEndDateRangeOnFocus() {
        this.updateEndDateRange()

        const { start, end, timeZone } = this.state.data.date;
        if(moment(start) === null || moment(end) === null) return;
        
        // if end date (day) is not start date
        // and has end date
        if(moment(end).tz(timeZone).date() !== moment(start).tz(timeZone).date()) {
            if(!isNaN(moment(end).tz(timeZone).date())) {
                const range = {...this.state.dateRange};
    
                // start time from 0:00 and not from start time
                range.end.minTime = moment().tz(timeZone).hours(0).minute(0);
                range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());
                
                this.setState({dateRange: range});
            }
        } 
    }

    handleChange(event) {
        var name = event.target.name;
        var value = event.target.value;

        var obj = {};
        name = name.split(".");

        switch(name.length) {
            case 2: 
                obj[name[0]] = {...this.state.data[name[0]]};
                obj[name[0]][name[1]] = value;
                break;
            default: 
                obj[name[0]] = value;
                break;
        }

        this.setState({data: {...this.state.data, ...obj}});
    }

    handleClosedChange(event) {
        const data = {...this.state.data};
        data.closed = !data.closed;

        this.setState({data: data});
    }

    handleDateChange(endOrStart) {
        return (value) => {
            const obj = {...this.state.data};
            obj.date[endOrStart] = value;
            
            // clear end date if start is empty
            if(endOrStart === 'start') {
                obj.date.end = null;
            }

            this.setState({data: obj});
            this.updateEndDateRange();
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        if(!this.state.eventFinised && this.validation()) {
            const { dispatch, events } = this.props;
            const data = {...this.state.data};
            data.date = {...this.state.data.date};

            if(this.state.eventStarted) data.date.start = events.list[events.currentEventID].date.start;

            dispatch(EventsActions.updateEvent(events.currentEventID, data));
        }
    }

    render() {
        const requestInProcess = this.props.events.updateEventProcess;
        const tz = this.state.data.date.timeZone;
        const convertToMoment = (date) => date ? moment(date).tz(tz) : null;

        return (
            <div id="eventSettingsForm">
                <BoxTitle icon="faCogs">
                    הגדרות האירוע
                </BoxTitle>
                <form onSubmit={this.handleSubmit} noValidate>
                    <Input
                        name="name"
                        value={this.state.data.name}
                        placeholder="שם האירוע:"
                        error={this.state.error.name}
                        errorText="שם האירוע לא תקין"
                        onChange={this.handleChange}
                        label={true}
                        disabled={this.state.eventFinised}
                    />
                    <Checkbox
                        name="closed"
                        isChecked={this.state.data.closed}
                        disabled={this.state.eventFinised}
                        onChange={this.handleClosedChange}
                        label="סגירת האירוע: "
                    />
                    <Input 
                        name="website.title"
                        value={this.state.data.website.title}
                        placeholder="כותרת עמוד הסלפי:"
                        error={this.state.error.website.title}
                        errorText="עד 200 תווים"
                        onChange={this.handleChange}
                        label={true}
                        disabled={this.state.eventFinised}
                    />
                    <div className="separate">
                        <div className="sepIcon"><FontAwesomeIcon icon={faClock}/></div>
                        <div className="speLine">&nbsp;</div>
                    </div>
                    <div className="explain">
                        <strong>שימו <FontAwesomeIcon icon={faHeart} /></strong>
                        <li>
                            כל הזמנים הם לפי שעון ישראל
                        </li>
                        <li>
                            לא ניתן לשנות את זמן התחלת האירוע לאחר תחילתו
                        </li>
                        <li>
                            לא ניתן לשנות את האירוע לאחר סיומו
                        </li>
                        <li>
                            זמן אירוע מקסימלי הוא: {REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS} שעות
                        </li>
                    </div>
                    <div className="labelMe">
                        <div className="inputLabel">
                            זמן תחילת האירוע:&nbsp;
                        </div>
                        <DatePicker 
                            showTimeSelect
                            isClearable={false}
                            timeFormat="H:mm"
                            timeIntervals={1}
                            minTime={this.state.dateRange.start.minTime} 
                            maxTime={this.state.dateRange.start.maxTime} 
                            minDate={this.state.dateRange.start.minDate}
                            maxDate={this.state.dateRange.start.maxDate}
                            selected={convertToMoment(this.state.data.date.start) || null}
                            onChange={this.handleDateChange('start')}
                            onSelect={this.updateStartDateRange}
                            disabled={this.state.eventFinised || this.state.eventStarted}
                            placeholderText="לחצו כאן על מנת לבחור תאריך ושעה"
                            dateFormat="LLL"
                            readOnly
                        />
                    </div>
                    <div className="labelMe">
                        <div className="inputLabel">
                            זמן סיום האירוע:&nbsp;
                        </div>

                        <DatePicker 
                            showTimeSelect
                            isClearable={false}
                            timeFormat="H:mm"
                            timeIntervals={1}
                            minTime={this.state.dateRange.end.minTime}
                            maxTime={this.state.dateRange.end.maxTime}
                            includeDates={[moment(this.state.dateRange.end.minDate), moment(this.state.dateRange.end.maxDate)]}
                            disabled={!this.state.data.date.start || this.state.data.date.start.length === 0 || this.state.eventFinised}
                            selected={convertToMoment(this.state.data.date.end) || null}
                            onChange={this.handleDateChange('end')}
                            onSelect={this.updateEndDateRange}
                            onFocus={this.updateEndDateRangeOnFocus.bind(this)}
                            placeholderText={!this.state.data.date.start || this.state.data.date.start.length === 0 ? "קודם בחרו זמן התחלה" : "לחצו כאן על מנת לבחור תאריך ושעה"}
                            dateFormat="LLL"
                            readOnly
                        />
                    </div>
                    <div className="separate">
                        <div className="sepIcon"><FontAwesomeIcon icon={faImages}/></div>
                        <div className="speLine">&nbsp;</div>
                    </div>
                    <Input
                        name="maxImages.event"
                        value={this.state.data.maxImages.event}
                        placeholder="מקסימום מגנטים (כולל שכפולים) באירוע:"
                        error={this.state.error.maxImages.event}
                        errorText={`בין- 0 ל- ${REACT_APP_MAX_IMAGES_EVENT}`}
                        onChange={this.handleChange}
                        label={true}
                        type="number"
                        disabled={this.state.eventFinised}
                    />
                    <Input
                        name="maxImages.user"
                        value={this.state.data.maxImages.user}
                        placeholder="מקסימום מגנטים לאורח:"
                        error={this.state.error.maxImages.user}
                        errorText={`בין- 0 ל- ${REACT_APP_MAX_IMAGES_EVENT}`}
                        onChange={this.handleChange}
                        label={true}
                        type="number"
                        disabled={this.state.eventFinised}
                    />
                    <Input
                        name="maxImages.copy"
                        value={this.state.data.maxImages.copy}
                        placeholder="מקסימום שכפולים למגנט:"
                        error={this.state.error.maxImages.copy}
                        errorText={`בין- 0 ל- ${REACT_APP_MAX_IMAGES_EVENT}`}
                        onChange={this.handleChange}
                        label={true}
                        type="number"
                        disabled={this.state.eventFinised}
                    />

                    {!this.state.eventFinised && <Submit process={requestInProcess} icon="faSave" text="עדכון הגדרות"/>}
                    {this.state.eventFinised && <div className="eventFinishedText">האירוע הסתיים</div>}
                    
                </form> 
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const EventSettingsFormWithRedux = connect(mapStateToProps)(EventSettingsForm);

export {EventSettingsFormWithRedux as EventSettingsForm};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/EventSettingsForm.jsx